const STORAGE_PREFIX = 'mfe-ebotics:tableColWidths:';

export function loadTableColumnWidths(storageKey) {
  try {
    const raw = localStorage.getItem(STORAGE_PREFIX + storageKey);
    if (raw == null || raw === '') return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed) ? parsed : {};
  } catch (e) {
    console.error('Failed to load table column widths:', e);
    return {};
  }
}

export function persistTableColumnWidths(storageKey, widths) {
  try {
    localStorage.setItem(STORAGE_PREFIX + storageKey, JSON.stringify(widths));
  } catch (e) {
    console.error('Failed to save table column widths:', e);
  }
}

export function clearTableColumnWidths(storageKey) {
  try {
    localStorage.removeItem(STORAGE_PREFIX + storageKey);
  } catch (e) {
    console.error('Failed to clear table column widths:', e);
  }
}
